import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ScheduleYourEstimate from "./sections/ScheduleYourEstimate";
import WhereWeWork from "./sections/WhereWeWork";
import QuickContactSiteInfo from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ScheduleYourEstimate />
      <WhereWeWork />
      <QuickContactSiteInfo />
    </div>;
}